import { IQueue, Queue } from './Queue';
import { EventEmitter, IEventEmitter } from './EventEmitter';

export type Config = {
  timeout: number;
};

export enum Event {
  CHANGE = 'change',
}

export interface IManager<T> {
  on(event: Event.CHANGE, callback: any): void;
  off(event: Event.CHANGE, callback: any): void;
  notify(toast: T, config?: Config): void;
}

export class Manager<T> implements IManager<T> {
  constructor(private queue: IQueue<T> = new Queue(), private eventEmitter: IEventEmitter = new EventEmitter()) {}

  on(event: Event.CHANGE, callback: any) {
    this.eventEmitter.subscribe(event, callback);
  }

  off(event: Event.CHANGE, callback: any) {
    this.eventEmitter.unsubscribe(event, callback);
  }

  notify(toast: T, config?: Config) {
    this.queue.enqueue(toast);
    this.eventEmitter.emit(Event.CHANGE, this.queue.getQueue());
    this.process(config);
  }

  private process(config?: Config) {
    const timeout = config?.timeout ?? 5000;

    setTimeout(() => {
      this.queue.dequeue();
      this.eventEmitter.emit(Event.CHANGE, this.queue.getQueue());
    }, timeout);
  }
}
